import React from 'react';
import { Card, CardBody, CardHeader, Col, Label, Row } from 'reactstrap';
import { queryKeyes } from 'shared/queryKeys';
import { useQuery } from 'react-query';
import { loadEvmruData, loadVesselBasicInformation } from 'VesselMaster/vesselMaster.hooks';
import Co2Emmission from '../Co2EmmissionEU';
import Loading from 'Components/Loading';
import ErrorComponent from 'Components/ErrorComponent';
import VesselDetailsHeader from 'Components/VesselDetailsHeader';

const EuMrvEtsPartial = (vesselId: any) => {
    /** useQueries */
    /** Table & graph data */
    const { data: eumrvData, isLoading: eumrvLoading, isError: eumrvError } = useQuery(
        [queryKeyes.vessel.Eumrv.key, vesselId.vesselId],
        async () => {
            return await loadEvmruData(parseInt(vesselId.vesselId));
        });
    /** Vessel's Basic Information */
    const { data: BasicInformation, isLoading: BasicInformationLoading, isError: BasicInformationError } = useQuery(
        [queryKeyes.vessel.VesselBasicInformation.key, vesselId.vesselId],
        async () => {
            return await loadVesselBasicInformation(parseInt(vesselId.vesselId))
        });
    /** useQueries end */

    if (eumrvLoading || BasicInformationLoading) {
        return <Loading message={''} />
    }
    if (eumrvError || BasicInformationError) {
        return <ErrorComponent message={''} />
    }

    /**
    * Calculate total of the given field
   * @returns number
   */
    const totalItem = () => {
        let total = 0;
        eumrvData.filter((item: any) => {
            return total += parseFloat((((item.co2_emission_fo + item.co2_emission_do) * item.emission_applicable_to_eu / 100) * 0.4).toFixed(2))
        })
        return isNaN(total) ? 0 : total;
    }
    return (
        <>
            <Row>
                <Col sm={2} className="d-flex align-items-end">
                    {eumrvData && eumrvData?.length > 0 &&
                        <Label>Last updated on :<br />
                            <strong className='text-muted'>{eumrvData[eumrvData.length - 1]?.start_date?.toString().substring(0, 10)}</strong>
                        </Label>
                    }
                </Col>
                <Col sm={10} className='pad-right-20'>
                    <VesselDetailsHeader />
                </Col>
            </Row>
            <Row>
                <Col sm={9}>
                    {!(eumrvLoading || BasicInformationLoading) && !(eumrvError || BasicInformationError) &&
                        <Card className='p-0'>
                            <CardHeader className='p-2 align-middle' >
                                <h5 className='m-0'>Basic information</h5>
                            </CardHeader>
                            <CardBody className='p-2 pb-0'>
                                <Row className='mb-2'>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Gross Tonnage&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.gross_tonnage}</strong>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Ice Class&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.ice_class}</strong>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <Label className='mb-0'>Power Output&nbsp;-&nbsp;</Label>
                                    </Col>
                                </Row>
                                <Row className='mb-2'>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Net Tonnage&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.net_tonnage}</strong>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>EEDI&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.eedi}</strong>
                                        </div>
                                    </Col>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Main propulsion power&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.main_propulsion_power}</strong>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Deadweight Tonnage&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.deadweight_tonnage}</strong>
                                        </div>
                                    </Col>
                                    <Col sm={{ size: 4, offset: 4 }}>
                                        <div className='ele_row1 d-flex align-items-center'>
                                            <Label className='mb-0'>Auxillary engine(s)&nbsp;</Label>
                                            <strong className='mr-2'>&nbsp;:&nbsp;{BasicInformation?.auxillary_engine}</strong>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    }
                </Col>
                <Col sm={3}>
                    <Card>
                        <CardHeader className='p-2'>
                            <h5 className='m-0'>YTD EUA</h5>
                        </CardHeader>
                        <CardBody className='nopadbottom'>
                            <h3 className='bold-lbl'>{totalItem().toFixed(0)}</h3>
                        </CardBody>
                    </Card>
                </Col>
            </Row >
            <Row>
                <Col sm={12}>
                    <Card className='p-0'>
                        <CardHeader className='p-2 align-middle'>
                            <h5 className='m-0'>Voyage Data</h5>
                        </CardHeader>
                        <CardBody className='nopadbottom p-0'>
                            <div className="table-responsive vertical-table-scroll">
                                <table className="table m-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center">Sr. No.</th>
                                            <th className='text-center'>Start date (dd/mm/yyyy)</th>
                                            <th className='text-center'>End date (dd/mm/yyyy)</th>
                                            <th className='text-center'>Departure port</th>
                                            <th className='text-center'>Arrival port</th>
                                            <th className='text-center' colSpan={2}>Fuel consumption</th>
                                            <th className='text-center' colSpan={2}>CO<sub>2</sub> emmission</th>
                                            <th className='text-center' colSpan={2}>CH<sub>4</sub> emmission</th>
                                            <th className='text-center' colSpan={2}>N<sub>2</sub>O emmission</th>
                                            <th className='text-center'>Applicability</th>
                                            <th className='text-center'>Emmission applicable to EU</th>
                                            <th className='text-center'>EUA</th>
                                        </tr>
                                        <tr>
                                            <th colSpan={5}></th>
                                            <th className='text-center'>Fuel oil</th>
                                            <th className='text-center'>Diesel oil</th>
                                            <th className='text-center'>Fuel oil</th>
                                            <th className='text-center'>Diesel oil</th>
                                            <th className='text-center'>Fuel oil</th>
                                            <th className='text-center'>Diesel oil</th>
                                            <th className='text-center'>Fuel oil</th>
                                            <th className='text-center'>Diesel oil</th>
                                            <th className='text-center' colSpan={3}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {eumrvData?.map((item: any, index: number) => {
                                            return (
                                                <tr>
                                                    <td className='text-center'>{index + 1}</td>
                                                    <td className='text-center'>{item?.start_date?.toString().substring(0, 10)} {item?.start_date?.toString().substring(11, 16)} 12:00</td>
                                                    <td className='text-center'>{item?.end_date?.toString().substring(0, 10)} {item?.end_date?.toString().substring(11, 16)}</td>
                                                    <td className='text-center'>{item?.departure_port}</td>
                                                    <td className='text-center'>{item?.arrival_port}</td>
                                                    <td className='text-center'>{item?.fo_fuel_consumption?.toFixed(2)}</td>
                                                    <td className='text-center'>{item?.do_fuel_consumption?.toFixed(2)}</td>
                                                    <td className='text-center'>{item?.co2_emission_fo?.toFixed(2)}</td>
                                                    <td className='text-center'>{item?.co2_emission_do?.toFixed(2)}</td>
                                                    <td className='text-center'>{item?.ch4_emission_fo?.toFixed(4)}</td>
                                                    <td className='text-center'>{item?.ch4_emission_do?.toFixed(4)}</td>
                                                    <td className='text-center'>{item?.n2o_emission_fo?.toFixed(4)}</td>
                                                    <td className='text-center'>{item?.n2o_emission_do?.toFixed(4)}</td>
                                                    <td className='text-center'>{item?.applicability} - {item?.emission_applicable_to_eu + '%'}</td>
                                                    <td className='text-center'>{item?.emission_applicable_to_eu === 0 ? 0 : ((item?.co2_emission_fo + item?.co2_emission_do) * item?.emission_applicable_to_eu / 100)?.toFixed(2)}</td>
                                                    <td className='text-center'>{(((item?.co2_emission_fo + item?.co2_emission_do) * item?.emission_applicable_to_eu / 100) * 0.4)?.toFixed(2)}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <Card className='p-0'>
                        <CardHeader className='p-2 align-middle'>
                            <h5 className='m-0'>CO<sub>2</sub> Emmission</h5>
                        </CardHeader>
                        <CardBody className='nopadbottom'>
                            <Co2Emmission pieChartData={eumrvData} />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </ >
    )
}

export default EuMrvEtsPartial